import './CardFooter.scss'

const CardFooter = ({ children }) => {
  return <div id="dashboard-layout-card-footer">{children}</div>
}

export default CardFooter
